import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@emotion/react';

const TableLoader = ({ size, color }) => {
  const theme = useTheme();
  return (
    <Spin
      indicator={
        <LoadingOutlined spin style={{ fontSize: size, color: color || theme.primaryColor }} />
      }
      size="small"
    />
  );
};

export default TableLoader;

TableLoader.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string
};
